import { combineEpics } from 'redux-observable';

import { route } from 'modules/mac/duck/actions/orders';

import { timeAction, counter } from './util';

export default combineEpics(
  counter(route.type, 'mac.orders'),
  timeAction(route.type, 'mac.orders'),
);
